"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createErrorLink = void 0;
var atoz_shiftapp_metrics_1 = require("@amzn/atoz-shiftapp-metrics");
var error_1 = require("@apollo/client/link/error");
var createErrorLink = function () {
    return (0, error_1.onError)(function (_a) {
        var _b;
        var operation = _a.operation, graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
        var dimensions = (_b = {},
            _b[atoz_shiftapp_metrics_1.DIMENSION_NAME.GQL_OPERATION_NAME] = operation.operationName,
            _b);
        if (graphQLErrors) {
            graphQLErrors.forEach(function (graphQLError) {
                if (graphQLError.message.includes(atoz_shiftapp_metrics_1.GQL_ERROR_TYPE.BAD_REQUEST)) {
                    // Log GQL 4XX error count for bad request error type
                    atoz_shiftapp_metrics_1.logger.emitCountMetric({
                        metricName: atoz_shiftapp_metrics_1.METRIC_NAME.GQL_ERROR_4XX,
                        dimensions: dimensions
                    });
                    // Log GQL error stacktrace
                    atoz_shiftapp_metrics_1.logger.error(graphQLError.message, {
                        graphQLError: graphQLError,
                        isCaught: true,
                        errorType: atoz_shiftapp_metrics_1.METRIC_NAME.GQL_ERROR_4XX,
                        errorContext: atoz_shiftapp_metrics_1.ERROR_CONTEXT.GQL,
                        dimensions: dimensions
                    });
                }
                else {
                    // Log GQL error count
                    atoz_shiftapp_metrics_1.logger.emitCountMetric({
                        metricName: atoz_shiftapp_metrics_1.METRIC_NAME.GQL_ERROR,
                        dimensions: dimensions
                    });
                    // Log GQL error stacktrace
                    atoz_shiftapp_metrics_1.logger.error(graphQLError.message, {
                        graphQLError: graphQLError,
                        isCaught: true,
                        errorType: atoz_shiftapp_metrics_1.METRIC_NAME.GQL_ERROR,
                        errorContext: atoz_shiftapp_metrics_1.ERROR_CONTEXT.GQL,
                        dimensions: dimensions
                    });
                }
            });
        }
        if (networkError) {
            if (
            // Apollo types don't play nicely with 'statusCode'
            // See https://github.com/apollographql/apollo-link/issues/300
            'statusCode' in networkError &&
                networkError.statusCode >= 400 &&
                networkError.statusCode < 500) {
                // Log GQL 4XX error count
                atoz_shiftapp_metrics_1.logger.emitCountMetric({
                    metricName: atoz_shiftapp_metrics_1.METRIC_NAME.GQL_ERROR_4XX,
                    dimensions: dimensions
                });
                // Log network error stacktrace for 4XX errors
                atoz_shiftapp_metrics_1.logger.error(networkError.message, {
                    networkError: networkError,
                    isCaught: true,
                    errorType: atoz_shiftapp_metrics_1.METRIC_NAME.GQL_ERROR_4XX,
                    errorContext: atoz_shiftapp_metrics_1.ERROR_CONTEXT.NETWORK,
                    dimensions: dimensions
                });
            }
            else {
                // Log GQL error count
                atoz_shiftapp_metrics_1.logger.emitCountMetric({
                    metricName: atoz_shiftapp_metrics_1.METRIC_NAME.GQL_ERROR,
                    dimensions: dimensions
                });
                // Log network error stacktrace for non-4XX errors
                atoz_shiftapp_metrics_1.logger.error(networkError.message, {
                    networkError: networkError,
                    isCaught: true,
                    errorType: atoz_shiftapp_metrics_1.METRIC_NAME.GQL_ERROR,
                    errorContext: atoz_shiftapp_metrics_1.ERROR_CONTEXT.NETWORK,
                    dimensions: dimensions
                });
            }
        }
    });
};
exports.createErrorLink = createErrorLink;
